import GuestGuard from "../components/GuestGuard";
import SettingsPage from "./SettingsPage";

export default function GuestSettingsPage() {
  return (
    <GuestGuard>
      <SettingsPage />
    </GuestGuard>
  );
}

